
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import DlgRemoveTrainingGuest from '@/modules/admin/trainings/_components/DlgRemoveTrainingGuest.vue';

  @Component({
    components: {DlgRemoveTrainingGuest},
  })
  export default class GuestTable extends Vue {
    @Prop({type: String, default: ''}) private trainingId!: any;

    @Action('admin/trainings/readOne') private readTraining!: any;

    @Getter('admin/ceos/all') private ceos!: any;
    @Getter('admin/trainings/guests') private guests!: any;

    private headers: any = [
      {
        text: 'Titel',
        align: 'left',
        value: 'title',
      },
      {
        text: 'Vorname',
        align: 'left',
        value: 'forname',
      },
      {
        text: 'Nachname',
        align: 'left',
        value: 'surname',
      },
      {
        text: 'Email',
        align: 'left',
        value: 'email',
      },
      {
        text: 'Unternehmen',
        align: 'left',
        value: 'company',
      },
      {
        text: '',
        align: 'right',
        value: '',
        sortable: false,
      },
    ];
    private loading: boolean = false;
    private search: string = '';

    private getCeo(ceoId) {
      let retCeo = {};
      this.ceos.some((ceo) => {
        if (ceo.id === ceoId) {
          retCeo = ceo;
          return true;
        }
      });
      return retCeo;
    }
  }
